import Animation from '../classes/Animation';
import GSAP from 'gsap';
import { SplitText } from "gsap/SplitText";

GSAP.registerPlugin(SplitText);

export default class Title extends Animation {
  constructor({ element, elements }) {
    super({ element, elements }); // Calls Animation.js, which sets up the observer
    this.splitText();
  }

  splitText() {
    if (!this.element) return;

    // 1. Create SplitText
    this.split = new SplitText(this.element, {
      type: "words, chars",
      charsClass: "chars"
    });

    this.chars = this.split.chars;
  }

  animateIn() {


    // CRITICAL FIX: Clear the CSS opacity on the parent wrapper (this.element) 
    // This is necessary because your CSS rule [data-animation='title'] { opacity: 0 } 
    // is hiding the entire container.
    GSAP.set(this.element, { opacity: 1 });


    // 1. Set the STARTING (hidden) state for the characters.
    GSAP.set(this.chars, {
      rotateY: 90,
      xPercent: -80,
      autoAlpha: 0 // The characters start fully invisible
    });


    // 2. Animate TO the final visible state.
    GSAP.to(this.chars, {
      duration: 1.8,
      rotateY: 0,  // Animate TO normal (facing forward)
      xPercent: 0, // Animate TO normal position
      autoAlpha: 1, // Animate TO visible
      ease: 'expo.out',
      // stagger: 0.001,
    });
  }
  animateOut() {
    // super.animateOut();
  }

  destroy() {
    this.split?.revert();
  }
}